import React from 'react';
// import { a } from 'react-router-dom';
import './HomeHeaderStyle.scss';
import logo from '../../../assets/images/logo.png';
import PostJobModalView from '../../../common/input/postjobModal/PostJobModalView';

const HomeHeaderView = (props) => {
  return (
    <>
      <div className="container-fluid">
        <nav className="cc-header_nav navbar">
          <a href="home" className="navbar-brand">
            <img src={logo} alt="logo image" className="cc-logo" />
          </a>
          {/* <a className="navbar-brand" href="#"><img src={logo} alt="logo image" className="cc-logo" /></a> */}
          {props.first_name && localStorage.getItem('token') ? (
            <li className="mobile_hide" style={{ listStyleType: 'none' }}>
              Welcome {props.first_name} {props.last_name}
            </li>
          ) : null}
          <ul className="ml-auto cc-header_contactlist">
            {props.id && localStorage.getItem('token') ? (
              <li className="mobile_hide">ID : {props.id}</li>
            ) : null}

            {/* <li><a href="tel:+97142314828" className="cc-phone_no"><i className="fa fa-phone" aria-hidden="true"></i> +97142314828</a></li> */}
            <li className="mobile_hide">
              <a href="tel:+97142314828">
                <button type="button" className="btn  cc-phone_no">
                  <i className="fa fa-phone" aria-hidden="true"></i>{' '}
                  +97142314828{' '}
                </button>
              </a>
            </li>
            <li className="mobile_hide">
              <a href="/find-jobs">
                <button type="button" className="btn btn-red regular">
                  Find a Job <i className="fa fa-search" aria-hidden="true"></i>
                </button>
              </a>
            </li>
            <li className="mobile_hide">
              <button
                onClick={props.handelpostjob}
                type="button"
                className="btn btn-red regular"
              >
                Post a Job <i className="fa fa-suitcase" aria-hidden="true"></i>
              </button>
            </li>
            <li className="mobile_hide">
              <button type="button" className="btn btn-blue shape-rounded">
                <i className="fa fa-user button-icon" aria-hidden="true"></i>
              </button>
            </li>

            <li>
              <div className={props.manuClass} style={{ overflow: 'auto' }}>
                <button onClick={props.closeMenuBar} className="sidebarClose">
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
                <ul onClick={props.closeMenuBar} className="cc-header_menulist">
                  {props.dashboard_location ? (
                    <>
                      <li>
                        <a href="/home">Home</a>
                      </li>
                      <li>
                        <a href="/about-us">About US</a>
                      </li>

                      <li>
                        <a href="/registrations/individual/form1">
                          Private Care Request Form
                        </a>
                      </li>
                      <li>
                        <a href="/registrations/council/form1">
                          Council Registration
                        </a>
                      </li>
                      <li>
                        <a href="/find-jobs">Find Jobs</a>
                      </li>
                      {/* <li>
                                            <a href="/job-details/22">Job Details</a>
                                        </li> */}
                      <li>
                        <a href="/job-post">Post Job</a>
                      </li>
                      {localStorage.getItem('is_admin') ? (
                        <li>
                          <a href="/admin/dashboard">Admin</a>
                        </li>
                      ) : null}

                      <li className="mobile_show">
                        <a href="tel:+97142314828">
                          <i className="fa fa-phone" aria-hidden="true"></i>{' '}
                          +97142314828
                        </a>
                      </li>

                      {localStorage.getItem('token') ? (
                        <li onClick={props.handlelogout}>
                          <a>Log Out</a>
                        </li>
                      ) : null}
                    </>
                  ) : (
                    //change href home
                    <>
                      <li>
                        <a href="/home">Home</a>
                      </li>
                      {localStorage.getItem('token') ? (
                        <li>
                          <a href="/dashboard">Dashboard</a>
                        </li>
                      ) : (
                        <li>
                          <a href="/login">Log In</a>
                        </li>
                      )}
                      <li>
                        <a href="/about-us">About US</a>
                      </li>
                      {localStorage.getItem('token') ? null : (
                        <li>
                          <a href="/user/registration-selection">
                            Sign-Up
                          </a>
                        </li>
                      )}

                      {/* <li>
                                            <a href="/registrations/individual/form1">Private Care Request Form</a>
                                        </li>
                                        <li>
                                            <a href="/registrations/council/form1">Council Registration</a>
                                        </li> */}
                      <li>
                        <a href="/find-jobs">Find Jobs</a>
                      </li>
                      {/* <li>
                                            <a href="/job-details/22">Job Details</a>
                                        </li> */}
                      <li>
                        <a onClick={props.handelpostjob}>Post Job</a>
                      </li>
                      {localStorage.getItem('is_admin') ? (
                        <li>
                          <a href="/admin/dashboard">Admin</a>
                        </li>
                      ) : null}

                      <li className="mobile_show">
                        <a href="tel:+97142314828">
                          <i className="fa fa-phone" aria-hidden="true"></i>{' '}
                          +97142314828
                        </a>
                      </li>

                      {localStorage.getItem('token') ? (
                        <li onClick={props.handlelogout}>
                          <a>Log Out</a>
                        </li>
                      ) : null}
                    </>
                  )}
                </ul>
              </div>
              <button
                onClick={props.showMenuBar}
                className="sidebarBtn"
                type="button"
              >
                <span></span>
              </button>
            </li>
          </ul>
        </nav>
      </div>

      <PostJobModalView
        hidePostJobModal={props.hidePostJobModal}
        post_modal_show={props.post_modal_show}
      />
    </>
  );
};

export default HomeHeaderView;
